import { render } from "./channelData.vue?vue&type=template&id=ad1164d2"
import script from "./channelData.vue?vue&type=script&lang=js"
export * from "./channelData.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/channel/channelData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad1164d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad1164d2', __exports__)) {
    console.log('reload')
    api.reload('ad1164d2', __exports__)
  }
  
  module.hot.accept("./channelData.vue?vue&type=template&id=ad1164d2", () => {
    console.log('re-render')
    api.rerender('ad1164d2', render)
  })

}


export default __exports__